module.exports = __webpack_public_path__ + "static/img/impact_boundary_2025.be0ef03.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/csr/stakeholder-identification/impact_boundary_2025.jpg
// module id = HSya
// module chunks = 99